import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=3608d33c&scoped=true&"
import script from "./Time.vue?vue&type=script&lang=js&"
export * from "./Time.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=3608d33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3608d33c",
  null
  
)

export default component.exports